module.exports = __webpack_public_path__ + "img/dsci0098.7d849477.jpg";